import { render } from "./CustomerCourse.vue?vue&type=template&id=51d6320c&scoped=true"
import script from "./CustomerCourse.vue?vue&type=script&lang=js"
export * from "./CustomerCourse.vue?vue&type=script&lang=js"

import "./CustomerCourse.vue?vue&type=style&index=0&id=51d6320c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d6320c"]])

export default __exports__